import { render } from "./ResendSMS.vue?vue&type=template&id=59f1c214&scoped=true&ts=true"
import script from "./ResendSMS.vue?vue&type=script&lang=ts"
export * from "./ResendSMS.vue?vue&type=script&lang=ts"

import "./ResendSMS.vue?vue&type=style&index=0&id=59f1c214&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f1c214"]])

export default __exports__